import { useQuery } from '@tanstack/react-query';
import { useRouter } from 'next/router';

import {
  getCommissionerChannelDataByUserId,
  getCommissionerChannelDataBySlug,
} from '~/services/commissioner/commissioner-service.service.api';

import type { Channel } from '../interfaces/channel.interface';

export function isValidUUID(str) {
  // Regular expression to check if string is a valid UUID
  const regexExp =
    /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/gi;

  return regexExp.test(str);
}

const useGetChannelData = (channelSlug) => {
  const router = useRouter();
  const {
    data: channelData,
    isLoading,
    error,
  // eslint-disable-next-line local-rules/require-query-stale-time
  } = useQuery({
    queryKey: ['commissioner/publicChannel', channelSlug],
    enabled: !!router.isReady && !!channelSlug,
    queryFn: () => {
      if (isValidUUID(channelSlug)) {
        return getCommissionerChannelDataByUserId(channelSlug as string);
      }

      return getCommissionerChannelDataBySlug(channelSlug as string);
    },
  });

  const channel = channelData?.data as Channel;

  return { channel, isLoading, error };
};

export default useGetChannelData;
